import { Box, SimpleGrid, Text } from "@chakra-ui/react";
import { ElevatorDevice } from "../components/ElevatorDevice.jsx";
import { useLocation } from "react-router-dom";
import React, { useState, useContext, useEffect } from "react";
import { SignalRContext } from "./SignalRContext";

export const ElevatorPage = () => {
    const { message } = useContext(SignalRContext);
    const [devices, setDevices] = useState([]);
    const location = useLocation();

    // Initialize elevator as an empty array by default
    const [elevator, setElevator] = useState([]);

    useEffect(() => {
        let deviceList = [];
        let newElevator = [];

        if (message?.flag === false) {
            newElevator = location.state || [];
        } else if (message?.flag === true) {
            console.log("flag = " + message.flag);
            setDevices(message.devices || []);
            deviceList = message.devices || [];

            newElevator = deviceList.filter((e) => {
                return e?.deviceType === 1;
            });
        }

        setElevator(newElevator);
        console.log("SignalR message received in Child2:", message);
    }, [message, location.state]);

    return (
        <Box mt="20px" ml="20px" mr="20px">
            <Text mb="20px" ml="5px" fontSize="sm"></Text>
            <SimpleGrid columns={[1, 1, 2, 3, 4, 4, 4]} spacing="10px">
                {elevator?.map((e) => (
                    <ElevatorDevice key={e.deviceId} device={e} />
                ))}
            </SimpleGrid>
        </Box>
    );
};